import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import logger from "../../../../../../utils/logger";
import { editLocationResource } from "../../../../../controller/reducer/locationResources";
import TagSelector from "../../../common/tag-selector";

const LocationResourceEditModal = ({ show, onClose, res, dispatch }) => {
  const [title, setTitle] = useState(res.title);
  const [link, setLink] = useState(res.link);
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [tags, setTags] = useState(
    res.tags.map((tag) => ({ value: tag, label: tag }))
  );

  const submitTask = (e) => {
    e.preventDefault();
    const data = {
      title,
      link,
      tags: tags.map((t) => t.value),
      email,
      comment,
      type: "edit",
    };
    logger()(data);
    dispatch(editLocationResource({ id: res._id, data }));
    onClose();
  };

  return (
    <Modal show={show} animation={false} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Suggest Changes in Resource</Modal.Title>
      </Modal.Header>
      <Form onSubmit={submitTask}>
        <Modal.Body>
          <Form.Group controlId="title">
            <Form.Label>Enter Title*</Form.Label>
            <Form.Control
              maxLength="200"
              required
              type="text"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Make it as descriptive as possible
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="link">
            <Form.Label>Enter Url*</Form.Label>
            <Form.Control
              required
              type="url"
              placeholder="Link"
              value={link}
              onChange={(e) => setLink(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">Url should be working</Form.Text>
          </Form.Group>
          <Form.Group controlId="tags">
            <Form.Label>Select Tags</Form.Label>
            <TagSelector isRemedy={false} tags={tags} setTags={setTags} />
          </Form.Group>
          <Form.Group controlId="comment">
            <Form.Label>Enter Comment*</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              maxLength="200"
              required
              type="text"
              placeholder="Comment"
              value={comment}
              onChange={(e) => setComment(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">Justify your changes</Form.Text>
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Enter Email</Form.Label>
            <Form.Control
              maxLength="50"
              type="email"
              placeholder="Email Here"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Enter email to receive response for your suggestion
            </Form.Text>
          </Form.Group>
          <Form.Text className="text-muted">* fields are mandatory</Form.Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default LocationResourceEditModal;
